var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.5C10 7.567 11.567 6 13.5 6C15.433 6 17 7.567 17 9.5C17 10.7568 16.3376 11.8589 15.3428 12.4761C15.8863 12.7691 16.3596 13.1757 16.7424 13.6341C17.5115 14.555 18 15.7776 18 17C18 17.5523 17.5523 18 17 18H10C9.44771 18 9 17.5523 9 17C9 15.7776 9.48849 14.555 10.2576 13.6341C10.6404 13.1757 11.1137 12.7691 11.6572 12.4761C10.6624 11.8589 10 10.7568 10 9.5ZM13.5 8C12.6716 8 12 8.67157 12 9.5C12 10.3284 12.6716 11 13.5 11C14.3284 11 15 10.3284 15 9.5C15 8.67157 14.3284 8 13.5 8ZM15.8213 16C15.6853 15.6119 15.4758 15.2376 15.2073 14.9161C14.7104 14.3211 14.0956 14 13.5 14C12.9044 14 12.2896 14.3211 11.7927 14.9161C11.5242 15.2376 11.3147 15.6119 11.1787 16H15.8213Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1C4.34315 1 3 2.34315 3 4V5H2C1.44772 5 1 5.44772 1 6C1 6.55228 1.44772 7 2 7H3V9H2C1.44772 9 1 9.44771 1 10C1 10.5523 1.44772 11 2 11H3V13H2C1.44772 13 1 13.4477 1 14C1 14.5523 1.44772 15 2 15H3V17H2C1.44772 17 1 17.4477 1 18C1 18.5523 1.44772 19 2 19H3V20C3 21.6569 4.34315 23 6 23H20C21.6569 23 23 21.6569 23 20V4C23 2.34315 21.6569 1 20 1H6ZM6 19H5V20C5 20.5523 5.44772 21 6 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H6C5.44772 3 5 3.44772 5 4V5H6C6.55228 5 7 5.44772 7 6C7 6.55228 6.55228 7 6 7H5V9H6C6.55228 9 7 9.44771 7 10C7 10.5523 6.55228 11 6 11H5V13H6C6.55228 13 7 13.4477 7 14C7 14.5523 6.55228 15 6 15H5V17H6C6.55228 17 7 17.4477 7 18C7 18.5523 6.55228 19 6 19Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonebook);
export default __webpack_public_path__ + "static/media/phonebook.f0c6eeac294bb80f30a5781cfed2d57d.svg";
export { ForwardRef as ReactComponent };